export default {
  metrics: {
    nrr: {
      title: 'NRR % (kwartalnie)',
      description:
        '(Przychody z subskrypcji {{currentMonth}} (Q{{currentQuarter}}) + Przychody z opłat serwisowych {{currentMonth}} (Q{{currentQuarter}})) / (Przychody z subskrypcji {{prevMonth}} (koniec Q{{prevQuarter}}) + Przychody z opłat serwisowych {{prevMonth}} (koniec Q{{prevQuarter}})) * 100',
    },
    upgrades: 'Ulepszenia kont',
    downgrades: 'Obniżenia kont',
    gte_c_tier: 'Konta ≥ ocena C',
    churn: 'Rezygnacje (zawieszone)',
    offers_turned_on: 'Oferty włączone',
    flyers_sent: 'Ulotki wysłane',
    on_google_ads_trial: 'Okres próbny Google Ads',
    converted_google_ads: 'Pomyślna konwersja Google Ads',
    first_time_500_monthly_sales: 'Pierwszy miesiąc €500',
    '14_days_no_sales': '14 dni online, brak przychodów',
  },
  details: {
    address: 'Adres',
    subscriptions: 'Aktywne subskrypcje',
    best_sales: 'Najlepszy miesiąc w historii',
    sales: 'Sprzedaż {{month}}',
    tier: 'Poziom {{month}}',
    live_from: 'Data uruchomienia',
    owner_phone: 'Telefon właściciela',
    owner_email: 'E-mail właściciela',
    owner: 'Właściciel',
    name: 'Restauracja',
    export_csv: 'Eksportuj CSV',
  },
  publish: 'Opublikuj',
  unpublish: 'Cofnij publikację',
};
